(function (root) {
  "use strict";

  function request(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        var message =
          response.status === 413 ? "That file is too large." : "We could not update your cart. Please try again.";
        var error = new Error(message);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  function updateMatching(cart, predicate) {
    var updates = {};
    cart.items.forEach(function (item) {
      if (predicate(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve();
    return request("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
    });
  }

  function removeGroup(cart, group) {
    return updateMatching(cart, function (item) {
      return item.properties && item.properties._ao_group === group;
    });
  }

  function clearOld(cart) {
    return updateMatching(cart, function (item) {
      return item.properties && item.properties._ao_group;
    });
  }

  async function addUploads(uploads) {
    for (var i = 0; i < uploads.length; i++) {
      var upload = uploads[i];
      var form = new FormData();
      form.append("id", upload.id);
      form.append("quantity", String(upload.quantity || 1));
      form.append("properties[Placement]", upload.placement);
      form.append("properties[Custom logo]", upload.file);
      form.append("properties[Custom logo file name]", upload.fileName);
      form.append("properties[_ao_group]", upload.group);
      form.append("properties[_ao_role]", "addon");
      await request("/cart/add.js", { method: "POST", body: form });
    }
  }

  async function checkout(options) {
    var group = "ao-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 7);
    var cart;
    try {
      var priced = options.core.calculate(options.sets, options.products);
      var payload = options.core.buildPayload(options.sets, options.products, group);
      cart = await request("/cart.js");
      await clearOld(cart);
      await addUploads(payload.customUploads);
      await request("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: payload.items }),
      });
      await request("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: options.note || "" }),
      });
      cart = await request("/cart.js");
      var actual = cart.items
        .filter(function (item) {
          return item.properties && item.properties._ao_group === group;
        })
        .reduce(function (sum, item) {
          return sum + item.final_line_price;
        }, 0);
      if (actual !== priced.total) {
        await removeGroup(cart, group);
        return { priceChanged: true };
      }
      return { ok: true };
    } catch (error) {
      try {
        cart = await request("/cart.js");
        await removeGroup(cart, group);
      } catch (_) {}
      throw error;
    }
  }

  root.AOBuilderCart = { checkout: checkout };
})(window);
